"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
  _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: !0
}), Object.defineProperty(exports, "CustomSegmentLabelPosition", {
  enumerable: !0,
  get: function get() {
    return _enums.CustomSegmentLabelPosition;
  }
}), Object.defineProperty(exports, "Transition", {
  enumerable: !0,
  get: function get() {
    return _enums.Transition;
  }
}), exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
  _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
  _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized")),
  _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
  _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
  _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
  _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
  _react = _interopRequireWildcard(require("react")),
  _propTypes = _interopRequireDefault(require("prop-types")),
  _d = require("d3"),
  _config = require("./core/config"),
  _render = require("./core/render"),
  _enums = require("./core/enums");
function _createSuper(a) {
  var b = _isNativeReflectConstruct();
  return function () {
    var c,
      d = (0, _getPrototypeOf2["default"])(a);
    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);
    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}
function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}
var ReactSpeedometer = function (a) {
  function b(a) {
    var d;
    return (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(d), "render", function () {
      return _react["default"].createElement("div", {
        ref: function ref(a) {
          return d.gaugeDiv = a;
        }
      });
    }), d.d3_refs = {
      pointer: !1,
      current_value_text: !1
    }, d;
  }
  (0, _inherits2["default"])(b, a);
  var c = _createSuper(b);
  return (0, _createClass2["default"])(b, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.renderGauge();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.forceRender ? this.renderGauge() : this.updateReadings();
    }
  }, {
    key: "renderGauge",
    value: function renderGauge() {
      this.config = (0, _config.getConfig)({
        PROPS: this.props,
        parentWidth: this.gaugeDiv.parentNode.clientWidth,
        parentHeight: this.gaugeDiv.parentNode.clientHeight
      }), (0, _d.select)(this.gaugeDiv).select("svg").remove(), this.d3_refs = (0, _render.render)({
        container: this.gaugeDiv,
        config: this.config
      }), (0, _render.update)({
        d3_refs: this.d3_refs,
        newValue: this.props.value,
        config: this.config
      });
    }
  }, {
    key: "updateReadings",
    value: function updateReadings() {
      this.config = (0, _config.updateConfig)(this.config, {
        labelFormat: (0, _d.format)(this.props.valueFormat || ""),
        currentValueText: this.props.currentValueText || "${value}"
      }), (0, _render.update)({
        d3_refs: this.d3_refs,
        newValue: this.props.value || 0,
        config: this.config
      });
    }
  }]), b;
}(_react.PureComponent);
(0, _defineProperty2["default"])(ReactSpeedometer, "displayName", "ReactSpeedometer"), ReactSpeedometer.propTypes = {
  value: _propTypes["default"].number.isRequired,
  minValue: _propTypes["default"].number.isRequired,
  maxValue: _propTypes["default"].number.isRequired,
  forceRender: _propTypes["default"].bool.isRequired,
  width: _propTypes["default"].number.isRequired,
  height: _propTypes["default"].number.isRequired,
  paddingHorizontal: _propTypes["default"].number.isRequired,
  paddingVertical: _propTypes["default"].number.isRequired,
  dimensionUnit: _propTypes["default"].string.isRequired,
  fluidWidth: _propTypes["default"].bool.isRequired,
  segments: _propTypes["default"].number.isRequired,
  maxSegmentLabels: _propTypes["default"].number,
  customSegmentStops: _propTypes["default"].array,
  customSegmentLabels: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    text: _propTypes["default"].string,
    position: _propTypes["default"].oneOf(["OUTSIDE", "INSIDE"]),
    fontSize: _propTypes["default"].string,
    color: _propTypes["default"].string
  })),
  needleColor: _propTypes["default"].string.isRequired,
  startColor: _propTypes["default"].string.isRequired,
  endColor: _propTypes["default"].string.isRequired,
  segmentColors: _propTypes["default"].array.isRequired,
  needleTransition: _propTypes["default"].string.isRequired,
  needleTransitionDuration: _propTypes["default"].number.isRequired,
  needleHeightRatio: _propTypes["default"].number.isRequired,
  ringWidth: _propTypes["default"].number.isRequired,
  textColor: _propTypes["default"].string.isRequired,
  valueFormat: _propTypes["default"].string.isRequired,
  currentValueText: _propTypes["default"].string.isRequired,
  currentValuePlaceholderStyle: _propTypes["default"].string.isRequired,
  labelFontSize: _propTypes["default"].string.isRequired,
  valueTextFontSize: _propTypes["default"].string.isRequired,
  valueTextFontWeight: _propTypes["default"].string.isRequired
}, ReactSpeedometer.defaultProps = _config.DEFAULT_PROPS;
var _default = ReactSpeedometer;
exports["default"] = _default;